/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../../../shared/theme/colors'
import { ticketColors } from '../../../shared/theme/ticketColors';
import { useOperationalConfirm } from '../../../shared/ui/useOperationalConfirm';
import { styles } from '../posShared.styles';
import { usePosCartContextOptional } from '../contexts/PosCartContext';
import { formatPosMoney } from '../../application/posMoneyFormat';

type PosParkedSaleBarProps = {
  canEdit?: boolean;
  hasParkedSale?: boolean;
  parkedLineCount?: number;
  parkedTotal?: number;
  onResumeParkedSale?: () => void;
  onDiscardParkedSale?: () => void;
};

export function PosParkedSaleBar(props: PosParkedSaleBarProps) {
  const ctx = usePosCartContextOptional();
  const {
    canEdit = false,
    hasParkedSale = false,
    parkedLineCount = 0,
    parkedTotal = 0,
    onResumeParkedSale = () => {},
    onDiscardParkedSale = () => {},
  } = {
    ...(ctx ?? {}),
    ...props,
  };
  const { confirm: confirmDiscard, ConfirmModal: DiscardConfirmModal } = useOperationalConfirm();

  if (!canEdit || !hasParkedSale) {
    return null;
  }

  const itemsLabel =
    parkedLineCount === 1 ? `1 \u00edtem` : `${parkedLineCount} \u00edtems`;
  const totalLabel = formatPosMoney(parkedTotal);

  return (
    <View style={styles.parkedSaleBarWrap}>
      <View style={styles.parkedSaleBanner}>
        <View style={styles.parkedSaleBannerTextWrap}>
          <Text style={styles.parkedSaleBannerTitle}>Venta pausada</Text>
          <Text style={styles.parkedSaleBannerMeta} numberOfLines={1}>
            {itemsLabel}
            {' \u00b7 '}
            <Text style={styles.parkedSaleBannerMetaAmt}>{totalLabel}</Text>
          </Text>
        </View>
        <TouchableOpacity
          testID="pos-resume-sale"
          accessibilityRole="button"
          accessibilityLabel="Retomar venta"
          style={styles.parkedSaleResumeBtn}
          onPress={onResumeParkedSale}
        >
          <Text style={styles.parkedSaleResumeBtnText}>Retomar venta</Text>
        </TouchableOpacity>
        <TouchableOpacity
          testID="pos-discard-parked-sale"
          accessibilityRole="button"
          accessibilityLabel="Descartar venta pausada"
          style={styles.parkedSaleBannerGhostBtn}
          onPress={() =>
            void confirmDiscard({
              title: 'Eliminar venta pausada',
              message: '¿Descartás la venta pausada?',
              confirmLabel: 'Eliminar',
              destructive: true,
              iconName: 'trash-outline',
            }).then((ok) => {
              if (ok) onDiscardParkedSale();
            })
          }
        >
          <Ionicons name="trash-outline" size={16} color={ticketColors.bad} />
        </TouchableOpacity>
      </View>
      {DiscardConfirmModal}
    </View>
  );
}
